var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.496 6.81L7.45 9.765l2.954-2.953M7.45 1.5v7.188",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 9.563v4.062a.562.562 0 01-.563.563H1.262a.563.563 0 01-.563-.563V9.562",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/icons/download-b0a0252f.svg";
export { SvgDownload as ReactComponent };